import {combineReducers} from "redux";
import lockNumber from "./locknumber";
import lockNumberByUser from "./lockNumberByUser";
import lockBetTemplate from "./lockBetTemplate";
import hasLotteryTemplate from "./hasLotteryTemplate";

const bettingConfigReducer = combineReducers({
    lockNumber,
    lockNumberByUser,
    lockBetTemplate,
    hasLotteryTemplate
});

export default bettingConfigReducer;
